<template>
  <div>
<div class="navigation-wrapper left"
      v-if="tabNavigation === 'full'"
    >
      <transition name="pop-in">
        <mfw-button
          v-if="!$formController.isFirstStep()"
          @click="$formController.prevStep()"
          color="accent"
          class="step-back"
          :disabled="$formController.loading"
        >Back</mfw-button>
      </transition>
    </div>
    <div 
      class="navigation-wrapper"
      :class="tabNavigation === 'full' ? 'right' : 'center'"
    >
      <transition name="pop-in" mode="out-in">
        <mfw-button
          v-if="!$formController.isLastStep()"
          key="next"
          @click="$formController.nextStep()"
          color="primary"
          class="step-next"
          :disabled="!currentStepValid || $formController.loading"
          :loading="$formController.loading"
        >Next</mfw-button>
        <mfw-button
          v-else
          key="submit"
          @click="$formController.submit()"
          color="primary"
          class="submit"
          :disabled="!$formController.wizardValid || $formController.loading"
          :loading="$formController.loading"
        >Submit</mfw-button>
      </transition>
    </div>
  </div>
</template>

<script>
import MfwButton from './MfwButton'
export default {
  components: {
    MfwButton
  },
  computed: {
    currentStepValid: {
      get() {
        return this.$formController.steps[this.$formController.currentStep].valid
      },
      set(val) {
        this.$formController.steps[this.$formController.currentStep].valid = val
      }
    },
    tabNavigation() {
      return this.$wizardConfig.tabNavigation
    }
  }
};
</script>

<style>
  .tab-navigation {
    align-items: center;
    padding: 12px;
    height: auto !important;
  }
  .mfw-form-wrapper.fullscreen .tab-navigation {
    position: absolute;
    bottom: 0;
  }
  .tab-navigation .v-btn .v-btn__content {
    min-width: 100px;
    font-size: 15px;
    color: white;
    opacity: 1 !important;
  }

  .navigation-wrapper {
    width: 50%;
  }
  .navigation-wrapper.right {
    text-align: right;
  }
  .navigation-wrapper.center {
    text-align: center;
  }
</style>
